import { gql } from '@apollo/client';

export const DEACTIVATE_USER_ACCOUNT = gql`
  mutation DeactivateUserAccountResult($userId: ID!) {
    deactivateUserAccount(userId: $userId) {
      __typename
      ... on DeactivateUserAccountSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
